const supportBtn = {
  label: 'AGREGAR'
};

export default supportBtn;
